import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { capitalizeFirstLetter, checkIfHotjarEnable, timeBetweenDates } from '../utils/helpers';
import { coveragePlans } from '../data/coveragePlan';
import history from '../utils/history';
import * as sinisterCardsActions from '../redux/actions/sinister-cards';
import SplitLayout from '../layout/SplitLayout';
import RimactTextArea from '../components/common/RimacTextArea/RimacTextArea';
import RimacTag from '../components/common/RimacTag/RimacTag';
import { PAGINAS_BY_STEP } from '../utils/constants';

const OtherCasePage = () => {
  const [viewStartTime] = useState(new Date());
  const dispatch = useDispatch();
  const descriptionText = useSelector(
    (state) => state.sinisterCards.otherDescription
  );
  const currentCoveragePlan = useSelector(
    (state) => state.coverages.currentPlan
  );
  const userFlowType = useSelector((state) => state.coverages.userFlowType);
  const sinisterList = useSelector((state) => state.sinisterCards.sinisterList);
  const currentUser = useSelector((state) => state.sinisterCards.userInfo);
  const currentUserName = `${capitalizeFirstLetter(
    currentUser?.name
  )} ${capitalizeFirstLetter(currentUser?.fatherLastName)}`;
  const [txtAreaText, setTxtAreaText] = useState(descriptionText);

  useEffect(() => {
    if (!viewStartTime) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    const endTime = new Date();
    const userTotalTime = timeBetweenDates(viewStartTime, endTime);

    if (checkIfHotjarEnable()) {
      // LAST
      window.digitalData.push({
        task: {
          name: 'Tiempo registrado - Mi Siniestro es Otro',
          time: userTotalTime,
        },
        event: 'trackTimeToComplete',
      });
    }
  }, [viewStartTime]);

  const leftContent = (
    <>
      <RimacTag
        customClasses="u-mb-8"
        color={coveragePlans[currentCoveragePlan].color}
        text={coveragePlans[currentCoveragePlan].name}
      />
      <div className="titleCont">
        <h1 className="u-mb-40 heading-1">Seguro de Protección de Tarjetas</h1>
        <p>
          <span className="u-font-bold">{currentUserName}</span>, estás
          solicitando:
        </p>
        <ul className="rimacCardCont">
          {sinisterList.map((cov) => (
            <div key={cov.code} className="rimacLiteCard u-mb-8">
              <img
                className="rimacLiteCard__img"
                src={cov.icon}
                alt={cov.title}
              />
              <p className="rimacLiteCard__title">{cov.title}</p>
            </div>
          ))}
        </ul>
      </div>
    </>
  );
  const rightContent = (
    <>
      <RimacTag
        customClasses="u-mb-16 mobile"
        color={coveragePlans[currentCoveragePlan].color}
        text={coveragePlans[currentCoveragePlan].name}
      />
      <div className="titleCont u-mb-40">
        <h3 className="u-mb-16">Describe lo sucedido en el siniestro</h3>
        <p>
          Trata de ser muy claro y conciso, eso ayudará a validar la situación.
        </p>
      </div>
      <RimactTextArea
        txtAreaValue={txtAreaText}
        txtAreaPlaceholder="Describe tu siniestro..."
        onTxtAreaChange={setTxtAreaText}
        txtAreaName="descripción del siniestro"
        txtAreaMaxLength={500}
      />
    </>
  );

  const onBackHandler = () => {
    dispatch(sinisterCardsActions.setStep({step: PAGINAS_BY_STEP.DETALLE_SINIESTRO.step, plan: currentCoveragePlan}));
    history.replace(`/${coveragePlans[currentCoveragePlan].uri}/detalle-siniestro`);
  };

  const onContinueHandler = () => {
    if (userFlowType === 'edit') {
      history.replace(`/${coveragePlans[currentCoveragePlan].uri}/resumen`);
      return;
    }

    dispatch(sinisterCardsActions.setOtherDescription(txtAreaText));
    dispatch(sinisterCardsActions.setStep({step: PAGINAS_BY_STEP.ANTES_EMPEZAR.step, plan: currentCoveragePlan}));
    history.replace(`/${coveragePlans[currentCoveragePlan].uri}/antes-de-comenzar`);
    if (checkIfHotjarEnable()) {
      // LAST
      window.digitalData.push({
        "action": {
          "group": "Tramites Siniestros - Protección Tarjeta BBVA",
          "category": `Detalle de siniestro - ${capitalizeFirstLetter(currentCoveragePlan.toLowerCase())}`,
          "name": "Mi siniestro es otro",
          "label": "Continuar"
        },
        "event": "trackAction"
      });
    }
  };

  console.log(userFlowType);

  return (
    <SplitLayout
      isNavActive={userFlowType === 'input'}
      containerClasses="otherCasePage"
      leftClasses="otherCasePage__left"
      rightClasses="otherCasePage__right"
      leftContent={leftContent}
      rightContent={rightContent}
      onNavBackClick={onBackHandler}
      onNavContinueClick={onContinueHandler}
      navCurrentStep={2}
      navTotalSteps={5}
      isNavNextDisabled={txtAreaText.length === 0}
      navStepperText={'PASO 2 DE 5'}
      navBtnText="Continuar"
    ></SplitLayout>
  );
};

export default OtherCasePage;
